import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import when from 'recompose/branch';
import has from 'lodash/has';
import { withModel } from '../data-providers/model';
import { getAvailableProductIds, findLowestProductPrice } from 'src/common/utils/product';

const filterItems = withProps(props => {
  const items = props.items
    .filter(item =>
      getAvailableProductIds(props.products)
        .includes(
          item.product.main.productId,
        ),
    )
    .map(({ product, ...item }) => ({
      ...item,
      ...product.productInformation,
      ...findLowestProductPrice(props.products, product.main.productId, { 
        locale: props.model.countryModel.locale 
      }),
      productId: product.main.productId,
      productTags: product.main.tags
    }))
    .filter(item => item.price);

  return {
    items
  };
}); 

const withFilteredProductItems = compose(
  withModel,
  withProps(props => ({
    products: props.model.eagleModel.products,
  })),
  when(props => props.items.every(item => has(item, 'product.main.productId')), filterItems)
);

export default withFilteredProductItems;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withFilteredProductItems.js